import type { BaseElement } from 'slate';

import type { AlineText, SuggestedTabEdit, TabOptions } from '../../internal';

export type TabType = 'tab';
export const tabType: TabType = 'tab';

export interface TabElement extends BaseElement {
  children: AlineText[];
  type: TabType;
  isPositional?: boolean;
  // This is modelled incorrectly. See EDI-431.
  options?: TabOptions;
  suggestedEdits?: SuggestedTabEdit[] | null;
}

export type TabProps = Omit<TabElement, 'children'>;

export function getIsRightAlignedTab(tab: Pick<TabElement, 'options'>): boolean {
  return tab.options?.type === 'right' || tab.options?.type === 'end';
}
